import { isEmpty } from 'remeda'
import styled, { css } from 'styled-components'
import { generateCss } from '@velasca/utils/generate-css'
import { ResponsiveImage } from '../ResponsiveImage/ResponsiveImage'

const soleColor = (sole: string) => {
  return css`
    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 100%;
      border-radius: 50px;
      background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0) 65%,
        ${sole} 65%
      );
    }
  `
}

export const RoundContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: ${({ theme }) => theme.colors.background};
`

export const SelectorButton = styled.button<{ selected: boolean }>`
  border: ${({ selected, theme }) => {
    return selected
      ? `3px solid ${theme.colors.border}`
      : `1px solid ${theme.colors.border}`
  }};
  border-radius: 50%;
  width: 3.5rem;
  height: 3.5rem;
  transition: border 0.1s ease-in-out;
  background: transparent;
  padding: 0;

  &:hover {
    border: 3px solid ${({ theme }) => theme.colors.border};
  }
`

const BaseColor = styled.div<{
  sole?: string | null
}>`
  position: relative;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  ${({ sole }) => sole && soleColor(sole)}
`

export const Pois = styled(BaseColor)<{ colors: string[] }>`
  background: radial-gradient(
    circle at center center,
    ${({ colors }) => colors[1]} 2px,
    ${({ colors }) => colors[0]} 2px
  );
`

export const Diamond = styled(BaseColor)<{ colors: string[] }>`
  background:
    linear-gradient(
        45deg,
        ${({ colors }) => colors[2]} 50%,
        rgba(0, 0, 0, 0) 50%
      )
      no-repeat scroll 0px 0px / 50% 50% padding-box border-box,
    linear-gradient(
        135deg,
        ${({ colors }) => colors[2]} 50%,
        rgba(0, 0, 0, 0) 50%
      )
      no-repeat scroll 0px 100% / 50% 50% padding-box border-box,
    linear-gradient(
        -45deg,
        ${({ colors }) => colors[1]} 50%,
        rgba(0, 0, 0, 0) 50%
      )
      no-repeat scroll 100% 0px / 50% 50% padding-box border-box,
    ${({ colors }) => colors[0]}
      linear-gradient(
        -135deg,
        ${({ colors }) => colors[1]} 50%,
        rgba(0, 0, 0, 0) 50%
      )
      no-repeat scroll 100% 100% / 50% 50% padding-box border-box;
`

export const Texture = styled(BaseColor)<{ texture: string; color: string }>`
  background-image: url(${({ texture }) => texture});
  background-color: ${({ color }) => color};
  background-blend-mode: overlay;
`

export const WeftImage = styled(ResponsiveImage)`
  display: block;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
`

export const Sole = styled.div<{ sole: string | null }>`
  position: relative;
  ${({ sole }) => sole && soleColor(sole)}
`

export const Colors = styled(BaseColor)<{
  colors: string[]
  weights?: number[]
  rotation: string
}>`
  ${({ colors, rotation, weights }) => {
    return (
      !isEmpty(colors) &&
      css`
        background: linear-gradient(
          ${rotation},
          ${generateCss(colors, weights)}
        );
      `
    )
  }}
`
